export default __webpack_public_path__ + "static/media/gallery_02.69e09873.jpg";